'use strict';

function PerformanceReviewSummaryController(performanceReviewService, $location, $interpolate, $q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.stepChange = stepChange;
  vm.questionIsComplete = questionIsComplete;
  vm.questionnaireIsLockable = questionnaireIsLockable;
  vm.questionnaireSetLock = questionnaireSetLock;
  vm.questionnaireSetAgreement = questionnaireSetAgreement;
  vm.questionnaireIsComplete = questionnaireIsComplete;
  vm.questionnaireWaitingForExpiration = questionnaireWaitingForExpiration;
  vm.hasRole = _hasRole;

  function $onInit() {
    vm.max = vm.data.max;
    vm.summary = vm.data.questions || [];
    vm.answers = vm.data.questions.map(function answer(question) { return question.answer; });
    vm.completed = vm.data.completed;
    vm.user = vm.data.user || {};
    vm.round = vm.data.round;
  }

  function questionnaireSetLock() {
    return $q.resolve().then(function() {
      if (vm.hasRole('Cenceo Manager')) {
        return $location.path(performanceReviewService.urls.basis.base({ round: vm.round }));
      }

      return $location.path('/');
    });
  }

  function questionnaireSetAgreement() {
    return performanceReviewService.update.agreement(vm.data.token).then(function(response) {
      vm.agreement = response.data.agreed_by_both;
      return response;
    });
  }

  function questionnaireIsLockable() {
    return vm.summary.every(vm.questionIsComplete);
  }

  function questionIsComplete(question) {
    return question.answer.state === 'COMPLETE';
  }

  function stepChange(to) {
    $location.path($interpolate('/performance-review/questionnaire/{{token}}/{{step}}')({ token: vm.data.token, step: to }));
    return $q.resolve();
  }

  function _hasRole(role) {
    return vm.me.groups.map(function(group) {
      return group.name;
    }).some(function (groupName) {
      return groupName === role;
    });
  }

  function questionnaireIsComplete() {
    return vm.questionnaireIsLockable() || vm.completed;
  }

  function questionnaireWaitingForExpiration() {
    var assessment = vm.user.token.assessment;
    return (new Date(assessment.transpire).getTime() < new Date().getTime() && assessment.is_lockable);
  }
}

module.exports = PerformanceReviewSummaryController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-summary/performance-review-summary.controller.js
 ** module id = 280
 ** module chunks = 0
 **/